const patientApiFetch = (url, options) => {
  return fetch(`/${url}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export default patientApiFetch;



// WEBPACK FOOTER //
// ./registration-react/api/patientApiFetch.js